import {
  Actions as CreepActions,
  CREEP_SKILL,
  // CREEP_UNDO_ACTION,
  CREEP_ACTIONS
} from './creep.actions';

import { Skill } from '../creep-skill';

export interface State {
  actions: Skill[];
}

export const initialState: State = {
  actions: []
};

export function reducer(state: State = initialState, action: CreepActions): State {
  console.log('reducer', action);

  switch (action.type) {
    case CREEP_SKILL: {
      return {
        ...state,
        actions: [
          ...state.actions,
          action.payload
        ]
      };
    }

    case CREEP_ACTIONS: {
      return {
        ...state,
        actions: [
          ...action.payload
        ]
      };
    }

    default:
      return state;
  }
}

export const selectActions = (state: State) => state.actions;



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/creep.reducer.ts